import React, { FunctionComponent } from 'react'
import { useInterval } from 'react-use'

type NextGameCountdownProps = {
	//
}

const NextGameCountdown: FunctionComponent<NextGameCountdownProps> = () => {
	const [time, setTime] = React.useState('')

	useInterval(() => {
		// calculate how many seconds remaining until midnight local time
		const now = new Date()
		const midnight = new Date(now)
		midnight.setHours(24, 0, 0, 0)
		const msUntilMidnight = midnight.getTime() - now.getTime()
		const secondsUntilMidnight = Math.floor(msUntilMidnight / 1000)
		const hours = Math.floor(secondsUntilMidnight / 3600)
		const minutes = Math.floor((secondsUntilMidnight % 3600) / 60)
		const seconds = secondsUntilMidnight % 60
		// const timeRemaining = `${hours}h ${minutes}m ${seconds}s`
		// format as "HH:MM:SS"
		const timeRemaining = `${hours.toString().padStart(2, '0')}:${minutes
			.toString()
			.padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
		setTime(timeRemaining)
	}, 1000)

	return <div className="next-game-countdown">{time}</div>
}

export default NextGameCountdown
